import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import CorporateNavbar from '@/components/CorporateNavbar';
import CorporateHero from '@/components/CorporateHero';
import LogoBand from '@/components/LogoBand';
import PathsSection from '@/components/PathsSection';
import ActiveWorkSection from '@/components/ActiveWorkSection';
import CorporateServices from '@/components/CorporateServices';
import SaaSProducts from '@/components/SaaSProducts';
import AboutSection from '@/components/AboutSection';
import CTASection from '@/components/CTASection';
import CorporateFooter from '@/components/CorporateFooter';

const results = [
  { label: 'Sparar 5–20 timmar / vecka',       desc: 'Repetitivt arbete som händer varje dag eller vecka sköts automatiskt.' },
  { label: 'Svar direkt istället för timmar',   desc: 'Kunder och kollegor får bekräftelser och svar utan manuell handpåläggning.' },
  { label: 'Mindre manuellt arbete',             desc: 'Rapporter, uppdateringar och formulär genereras utan att någon behöver göra det.' },
];

const Index = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Helmet>
        <title>Aifinity AB — AI-automation och SaaS för svenska företag</title>
        <meta name="description" content="Vi automatiserar det som tar er tid. AI-workflows, chatbotar och SaaS-produkter för svenska B2B-företag. Snabb leverans, inga mellanhänder." />
        <meta property="og:title" content="Aifinity AB — AI-automation och SaaS" />
        <meta property="og:description" content="Vi automatiserar det som tar er tid — AI-workflows, chatbotar och egna SaaS-produkter för svenska företag." />
        <meta property="og:url" content="https://aifinity.se" />
        <link rel="canonical" href="https://aifinity.se" />
      </Helmet>
      <CorporateNavbar />
      <CorporateHero />
      <LogoBand />
      <PathsSection />
      <ActiveWorkSection />

      {/* ── Vad du får i praktiken ── */}
      <section className="py-16 bg-surface-subtle border-t border-border-light">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-brand-indigo mb-8 text-center">
              Vad du får i praktiken
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {results.map(({ label, desc }) => (
                <div key={label} className="bg-white rounded-2xl border border-border-light p-6 shadow-sm">
                  <p className="text-[15px] font-bold text-text-primary mb-2">{label}</p>
                  <p className="text-[13px] text-text-secondary leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CorporateServices />
      <SaaSProducts />
      <AboutSection />
      <CTASection />
      <CorporateFooter />
    </div>
  );
};

export default Index;
